import { useCallback, useEffect, useState } from "react";
import { Button, Modal as BootstrapModal } from "react-bootstrap";
import { Form, Formik } from "formik";
import { useTranslation } from "react-i18next";

import Domain from "../../services/domain";
import { useHistory } from "react-router-dom";
import RadioButtonList from "../controls/form/RadioButtonList";
import { useGetDomain } from "../../common/Hooks";
import Utils from "../../utils/utils";
import Product from "../../services/product";

const ChangeDomain = ({ show, cancelText, onCancel = () => { } }) => {
    const [domains, setDomains] = useState([]);
    const [selectedDomain, setSelectedDomain] = useState("");
    const [currentDomain, setCurrentDomain] = useGetDomain();
    const history = useHistory();
    const [translate] = useTranslation();
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        setShowModal(show);
    }, [show]);

    const populateDomains = useCallback(async () => {
        const response = await Domain.getAllDomains();
        if (!response.error) {
            setDomains(response.data);
            if (currentDomain) {
                setSelectedDomain(currentDomain);
            }
        }
    }, [currentDomain]);

    useEffect(() => {
        if (showModal) {
            populateDomains();
        }
    }, [showModal, populateDomains ]);

    const setDomain = useCallback(async () => {
        const selectedDomainObj = domains.filter(
            (domain) => domain._id === selectedDomain
        );
        window.sessionStorage.setItem(
            "root-domain",
            selectedDomainObj[0].rootDomain || false
        );
        const promptInfoResponse = await Product.getDomainPromptInfo(selectedDomain);
        const { helpUrl, termsAndConditionsUrl } = promptInfoResponse.data;
        setCurrentDomain({
            _id: selectedDomain,
            name: selectedDomainObj[0].name,
            helpUrl,
            termsAndConditionsUrl
        });
        setShowModal(false);
        history.push("/");
        window.location.reload();
    }, [domains, selectedDomain, setCurrentDomain, history, setShowModal]);

    const updateSelection = (selected) => {
        setSelectedDomain(selected);
    };

    return (
        <BootstrapModal show={showModal} backdrop="static" scrollable={true}>
            <Formik
                initialValues={{
                    domain: [...domains]
                }}
                onSubmit={setDomain}
                enableReinitialize
            >
                <Form className="d-flex flex-column overflow-hidden">
                    <BootstrapModal.Header className="h5 text-secondary">
                        {translate("OTM_SELECT_DOMAIN")}
                    </BootstrapModal.Header>
                    <BootstrapModal.Body>
                        <RadioButtonList
                            name="domain"
                            heading={translate("OTM_SELECT_A_DOMAIN")}
                            onSelect={updateSelection}
                        />
                    </BootstrapModal.Body>
                    <BootstrapModal.Footer>
                        <Button
                            type="submit"
                            className="btn btn-primary btn-sm"
                            disabled={Utils.isEmpty(selectedDomain)}
                        >
                            {translate("OTM_SELECT")}
                        </Button>
                        <Button
                            onClick={onCancel}
                            variant="secondary"
                            className="btn-sm"
                        >
                            {translate(cancelText)}
                        </Button>
                    </BootstrapModal.Footer>
                </Form>
            </Formik>
        </BootstrapModal>
    );
};

export default ChangeDomain;
